<div class="access-blocked-container">
  <div class="access-blocked-content">
    <div class="mb-3">
      <i class="{{ icon }} text-warning" style="font-size: 4rem"></i>
    </div>

    <h4 class="mb-3 text-dark">{{ title }}</h4>

    <p class="text-muted mb-4">
      {{ message }}
    </p>
  </div>
</div>
